import { render, staticRenderFns } from "./ScheduleMenu.vue?vue&type=template&id=6d2e6004&scoped=true"
import script from "./ScheduleMenu.vue?vue&type=script&lang=js"
export * from "./ScheduleMenu.vue?vue&type=script&lang=js"
import style0 from "./ScheduleMenu.vue?vue&type=style&index=0&id=6d2e6004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e6004",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TimeLineSmall: require('/app/components/TimeLineSmall.vue').default,ScheduleAccordion: require('/app/components/schedule/ScheduleAccordion.vue').default})
